module.exports = __webpack_public_path__ + "static/img/4-EN.47c65d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/4-EN.png
// module id = foty
// module chunks = 1